export const EMPTY = 'EMPTY'
export const LOADING = 'LOADING'
export const READY = 'READY'
export const ERROR = 'ERROR'
